export default __webpack_public_path__ + "static/media/pencil.30016a0d.svg";